import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from './AppContext';
import { useRef } from 'react';

const ClockContext = React.createContext()

function ClockProvider({ children, secondsWork, secondsBreak, secondsLongBreak }) {
    const { totalPomodoros, openTimerModal } = useContext(AppContext)
    const [clockState, setClockState] = useState(false);
    const [countDown, setCountDown] = useState(secondsWork); // Inicializa el tiempo restante en 10 segundos
    const [clockString, setClockString] = useState('');
    const [disableBtn, setDisableBtn] = useState(false);
    const [animationValue, setAnimationValue] = useState(0);
    const [pomodoroState, setPomodoroState] = useState('Working');
    const [breakMode, setBreakMode] = useState(false);
    const [pomodoroCount, setPomodoroCount] = useState(totalPomodoros);
    const [longBreakCounter, setLongBreakCounter] = useState(5);
    const [plantAnimationValue, setPlantAnimationValue] = useState(0);
    const [allSeconds, setAllSeconds] = useState((secondsWork * totalPomodoros) + (secondsBreak * totalPomodoros));
    const addAnimationValueWork = 100 / secondsWork
    const addAnimationValueBreak = (100 / secondsBreak)
    const [sessionEnd, setSessionEnd] = useState(false);

    const timerWorker = useRef(null)

    useEffect(() => {
        setPomodoroCount(totalPomodoros)
    }, [totalPomodoros])

    useEffect(() => {
        setClockState(false)
        setCountDown(secondsWork)
        setDisableBtn(false)
        setAnimationValue(0)
        setPomodoroState('Working')
        setLongBreakCounter(5)
        setPlantAnimationValue(0)
        setBreakMode(false)
        setAnimationValue(0)
        setAllSeconds((secondsWork * totalPomodoros) + (secondsBreak * totalPomodoros))
        setSessionEnd(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openTimerModal])

    useEffect(() => {
        const proporcion = 100 / (((secondsWork * totalPomodoros) + (secondsBreak * totalPomodoros)) + 1)
        setPlantAnimationValue(prevValue => prevValue + proporcion)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [allSeconds])

    // Working with the value of the sky's animation
    useEffect(() => {
        if (pomodoroState === 'Working') {
            if (countDown !== 0) {
                setAnimationValue(prevValue => prevValue + addAnimationValueWork)
            }
        } else {
            if (countDown !== 0) {
                setAnimationValue(prevValue => prevValue + addAnimationValueBreak)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [countDown])

    // Seconds to hours:minutes:seconds format
    const secondsToString = (seconds) => {
        let hour = Math.floor(seconds / 3600);
        hour = (hour < 10) ? '0' + hour : hour;

        let minute = Math.floor((seconds / 60) % 60);
        minute = (minute < 10) ? '0' + minute : minute;

        let second = seconds % 60;
        second = (second < 10) ? '0' + second : second;

        if (parseInt(hour) === 0) {
            return minute + ":" + second;
        } else {
            return hour + ':' + minute + ':' + second;
        }
    }

    useEffect(() => {
        setLongBreakCounter(prevVal => prevVal - 1)
    }, [pomodoroCount])

    // Logic of the timer 
    useEffect(() => {
        timerWorker.current = new window.Worker(process.env.PUBLIC_URL + '/timerWorker.js')
        timerWorker.current.postMessage({ allSeconds, clockState })
        timerWorker.current.onmessage = (e) => {
            setAllSeconds(e.data)
            setCountDown(prevTime => {
                if (prevTime - 1 === 0) {
                    if (longBreakCounter === 1 && pomodoroState === "Break") {
                        setBreakMode(true)
                        setPomodoroState('Long Break')
                        setCountDown(secondsLongBreak)
                        setAnimationValue(100)
                        setLongBreakCounter(5)
                        return 4
                    } else if (pomodoroState !== 'Break' && pomodoroState !== 'Long Break') {
                        setBreakMode(true)
                        setPomodoroState('Break')
                        setCountDown(secondsBreak)
                        setAnimationValue(100)
                        return secondsBreak
                    } else {
                        if (pomodoroCount !== 1) {
                            setBreakMode(false)
                            setPomodoroState('Working')
                            setAnimationValue(0)
                            setCountDown(secondsWork)
                            setPomodoroCount(prevPomodoroCount => prevPomodoroCount - 1)
                            return secondsWork
                        } else {
                            setDisableBtn(true)
                            setClockState(false)
                            setSessionEnd(true)
                            return 0
                        }
                    }
                }
                return prevTime - 1;
            });
        }
        return () => {
            timerWorker.current.terminate()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clockState, pomodoroState]);

    // Calling the seconds to string converter
    useEffect(() => {
        setClockString(secondsToString(countDown))
    }, [countDown])

    return (
        <ClockContext.Provider value={{
            clockState,
            setClockState,
            clockString,
            countDown,
            setCountDown,
            disableBtn,
            setDisableBtn,
            animationValue,
            pomodoroState,
            breakMode,
            pomodoroCount,
            totalPomodoros,
            longBreakCounter,
            plantAnimationValue,
            allSeconds,
            sessionEnd
        }}>
            {children}
        </ClockContext.Provider>
    )
}

export { ClockContext, ClockProvider }